export enum InvoiceSeparation {
  BY_COST_CENTER = "BY_COST_CENTER",
  BY_WORK_LOCATION = "BY_WORK_LOCATION",
  SINGLE = "SINGLE",
}

export const invoiceSeparationOptions = Object.values(InvoiceSeparation);

export enum YesNoOptions {
  Yes = "yes",
  No = "no",
}

export const YES_NO_OPTIONS = [YesNoOptions.Yes, YesNoOptions.No];
export const INVOICE_FORMAT_OPTIONS = [
  "ByCustCCs",
  "ByProductByCustCCs",
  "ByTalent",
  "ByTalentByProductByCustCCs",
  "ByWorkTitleByTalentByProduct",
];
export const INVOICE_BREAKDOWN_OPTIONS = [
  "Talent", // Henkilöittäin
  // "Assignment", // Työtehtävittäin
  "CustCCs", // Kustannuspaikoittain
  // "CUstCCsWithTotal", // Lisää yhteensä -rivi per kustannuspaikka
  "EntryWithAssignment", // Yksittäiset kirjaukset työtehtävittäin
  // "EntryWithAssignmentWithTalent", // Järjestä henkilöittäin
  "OriginalPriceAndMultiplierToInvoiceRows", // Alkuperäinen hinta ja kerroin laskuriveille
  "ExpenseTypeCodes", // Palkkalajeittain
];

export enum ContractsTabModalTypes {
  Contract = "Contract",
  EditExistingPricing = "EditExistingPricing",
  NewPricingFromExistingData = "NewPricingFromExistingData",
  NewPricingNoExistingData = "NewPricingNoExistingData",
  PricingPerTes = "PricingPerTes",
  PricingGeneralSettings = "PricingGeneralSettings",
}

export enum PricingCategory {
  BaseHours = "baseHours",
  Supplements = "supplements",
  TaxFreeCompensations = "taxFreeCompensations",
  SickLeave = "sickLeave",
  MidweekHolidays = "midweekHolidays",
  ShortTimeWorkingScheme = "shortTimeWorkingScheme",
  HolidaySalary = "holidaySalary",
  HolidayBonus = "holidayBonus",
}

export const PRICING_CATEGORY_KEYS = Object.values(PricingCategory);

export const PRICING_CATEGORY_API_KEY_MAP = {
  [PricingCategory.BaseHours]: "BaseHours",
  [PricingCategory.Supplements]: "Supplements",
  [PricingCategory.TaxFreeCompensations]: "TaxFreeCompensations",
  [PricingCategory.SickLeave]: "SickLeave",
  [PricingCategory.MidweekHolidays]: "MidweekHolidays",
  [PricingCategory.ShortTimeWorkingScheme]: "ShortTimeWorkingScheme",
  [PricingCategory.HolidaySalary]: "HolidaySalary",
  [PricingCategory.HolidayBonus]: "HolidayBonus",
};

export enum PricingCategorySelection {
  Multiplier = "COST", // Kerroin
  FixedPrice = "AMOUNT", // Kiinteä hinta
  NotBilled = "NONE", // Ei laskuteta
  Override = "OVERRIDE", // Kiinnityskohtainen hinta (kertoimella)
}

export const PRICING_SPEC_DEFAULT_OPTIONS = [
  PricingCategorySelection.Multiplier,
  PricingCategorySelection.NotBilled,
];

export enum PricingSpecialsPricingRuleType {
  BY_CATEGORY = "BY_CATEGORY",
  BY_SHIFT = "BY_SHIFT",
}

export enum PricingGeneralSetting {
  InvoiceFee = "invoiceFee",
  CreditInvoiceFee = "creditInvoiceFee",
}

export enum PricingSpecialSetting {
  ExpressOrder = "expressOrder",
  OfficeOrder = "officeOrder",
  EarlyBirdOrder = "earlyBirdOrder",
  LongOrder = "longOrder",
  CustomerRecruit = "customerRecruit",
}

export const PRICING_SPECIAL_SETTING_KEYS = Object.values(
  PricingSpecialSetting,
);

export const EMPTY_PRICING_BY_ITEM = {
  ids: [],
  multiplier: "",
  type: PricingCategorySelection.Multiplier,
};

export const PRICING_SPECIAL_PATH_START = "specials";

export const INVOICE_LANGUAGE_OPTIONS = ["FI", "EN", "SV"];

export const SHOW_ONLY_FOR_HOURLY_BILLING_LABEL_FOR_CATEGORIES = [
  PricingCategory.SickLeave,
  PricingCategory.MidweekHolidays,
  PricingCategory.ShortTimeWorkingScheme,
  PricingCategory.HolidaySalary,
  PricingCategory.HolidayBonus,
];
export const SHOW_ONLY_FOR_HOURLY_BILLING_LABEL_FOR_SALARY_TYPE = [
  "liukumavapaa",
  "tyoaikapankkivapaa",
];

export const HIDE_OVERRIDE_AND_FIXED_PRICE_FOR_SALARY_TYPE = ["kuukausipalkka"];
